import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { getPortal } from "@/lib/portal";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Privacidad from "@/pages/Privacidad";
import Soporte from "@/pages/Soporte";
import Contacto from "@/pages/Contacto";
import AdminDashboard from "@/pages/AdminDashboard";
import OwnerPanel from "@/pages/OwnerPanel";
import Storefront from "@/pages/Storefront";
import OrderStatus from "@/pages/OrderStatus";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// On admin.* / restaurant.* subdomains, the root path shows the matching login.
function RootRoute() {
  return getPortal() ? <Login /> : <Landing />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="/login" element={<Login />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/soporte" element={<Soporte />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/r/:slug" element={<ErrorBoundary><Storefront /></ErrorBoundary>} />
            <Route path="/order/:orderId" element={<OrderStatus />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["superadmin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/owner"
              element={
                <ProtectedRoute roles={["owner"]}>
                  <OwnerPanel />
                </ProtectedRoute>
              }
            />
          </Routes>
          </BrowserRouter>
        </LanguageProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
